import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
//import { DateRangeFacet } from '@plone/volto/components/manage/Blocks/Search/components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Checkbox /*, Button*/ } from 'semantic-ui-react';
// import { Icon } from '@plone/volto/components';
// import zoomSVG from '@plone/volto/icons/zoom.svg';

import { Select } from '@package/components/Widgets';
import { getSearchPrjFilters } from '@package/actions';
import {
  BUDGET_OPTIONS,
  CONTRIBUTO_FC_OPTIONS,
  getOptionByValue,
} from './utils';
import messages from './messages';

const SearchForm = ({ filters, setFilters, results_region_id, reset }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const searchFiltersStatus = useSelector(
    (state) => state.searchProjectFilters,
  );
  const searchFilters = useSelector(
    (state) => state.searchProjectFilters.result,
  );
  useEffect(() => {
    if (
      !searchFilters &&
      !searchFiltersStatus.loading &&
      !searchFiltersStatus.loaded
    ) {
      dispatch(getSearchPrjFilters());
    }
  }, []);

  const SelectFilter = ({ items, placeholder, field }) =>
    items?.length > 0 ? (
      <Select
        classNameWrapper="widget"
        placeholder={placeholder}
        value={filters[field]}
        options={items
          .filter((t) => t?.length > 0)
          .map((t) => {
            return { label: t, value: t };
          })}
        onChange={(v) => {
          setFilters({ ...filters, [field]: v });
        }}
        aria-controls={results_region_id}
      />
    ) : (
      <></>
    );

  return searchFilters ? (
    <div className="search-prj-filters">
      <div className="search-prj-filters-options">
        {/* Bando */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_bando)}
          items={searchFilters.titolo_bando}
          field="titolo_bando"
        />
        {/* Anno */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_anno)}
          items={searchFilters.anno_bando}
          field="anno_bando"
        />
        {/* Organizzazione */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_organizzazione)}
          items={searchFilters.organizzazione_po}
          field="organizzazione_po"
        />
        {/* Veste giuridica */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_veste_giuridica)}
          items={searchFilters.veste_giuridica_capofila}
          field="veste_giuridica_capofila"
        />
        {/* Provincia */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_provincia)}
          items={searchFilters.provincia}
          field="provincia"
        />
        {/* Tipologia di intervento */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_tipologie_intervento)}
          items={searchFilters.tipologie_intervento}
          field="tipologie_intervento"
          multiple
        />
        {/* Budget */}
        <Select
          classNameWrapper="widget"
          placeholder={intl.formatMessage(messages.filter_budget)}
          value={filters.budget_iniziale_progetto?.value}
          options={BUDGET_OPTIONS}
          onChange={(v) => {
            setFilters({
              ...filters,
              budget_iniziale_progetto: getOptionByValue(BUDGET_OPTIONS, v),
            });
          }}
          aria-controls={results_region_id}
        />
        {/* Contributo fondazione */}
        <Select
          classNameWrapper="widget"
          placeholder={intl.formatMessage(messages.filter_contributo_fc)}
          value={filters.contributo_deliberato_fc?.value}
          options={CONTRIBUTO_FC_OPTIONS}
          onChange={(v) => {
            setFilters({
              ...filters,
              contributo_deliberato_fc: getOptionByValue(
                CONTRIBUTO_FC_OPTIONS,
                v,
              ),
            });
          }}
          aria-controls={results_region_id}
        />
        {/* Partner */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_partner)}
          items={searchFilters.partenariato}
          field="partenariato"
        />
        {/* Parole chiave */}
        <SelectFilter
          placeholder={intl.formatMessage(messages.filter_subject)}
          items={searchFilters.Subject}
          field="Subject"
        />

        {/* <div className="widget">
          <DateRangeFacet
            facet={{
              '@id': 'start-end-date',
              title: intl.formatMessage(messages.filter_date),
              field: { value: 'date' },
            }}
            value={filters.date}
            onChange={(f, v) => {
              setFilters({ ...filters, date: v });
            }}
            aria-controls={results_region_id}
          />
        </div> */}
      </div>
      <div className="search-prj-filters-actions">
        <div className="left">
          <button
            onClick={() => {
              reset();
            }}
            size="mini"
            className="clear-filters"
            aria-controls={results_region_id}
          >
            {intl.formatMessage(messages.reset_filters)}
            <FontAwesomeIcon icon={['far', 'trash-alt']} className="icon" />
          </button>
        </div>
        <div className="right">
          <Checkbox
            toggle
            label={intl.formatMessage(messages.in_progress)}
            id="in_progress"
            onChange={(d, data) => {
              setFilters({
                ...filters,
                stato_progetto: data.checked ? 'in_corso' : null,
              });
            }}
            checked={filters.stato_progetto === 'in_corso' ?? false}
            aria-controls={results_region_id}
          />
          {/* <Button
            onClick={() => {
              doSearch();
            }}
            primary
            className="submit-button"
            aria-controls={results_region_id}
          >
            {intl.formatMessage(messages.search)}
            <Icon name={zoomSVG} />
          </Button> */}
        </div>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default SearchForm;
